// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yMC4","left":"styles_left__1nG0g"};